import React, { Component } from "react";
import { auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";

class AddToListButton extends Component {
  constructor(props) {
    super(props);

    this.addUserToRecipient = this.addUserToRecipient.bind(this);

    this.state = {
      selectedMembers: [],
    };
  }

  addUserToRecipient() {
    customLog(this.props.data);
    const data = this.props.data;
    const { dataCallBack } = this.props;

    const memberDetails = {
      memberEmail: data.memberEmail,
      memberUid: data.memberUid,
    };
    this.setState(
      {
        selectedMembers: [...this.state.selectedMembers, memberDetails],
      },
      () => {
        dataCallBack(this.state.selectedMembers);
      }
    );
  }
  render() {
    // console.log(this.props);
    return (
      <div>
        <button
          className={"select-btn"}
          disabled={
            this.props.data.isSuperAdmin ||
            this.props.data.memberEmail === auth.currentUser.email
          }
          onClick={this.addUserToRecipient}
        >
          &#43;
        </button>
      </div>
    );
  }
}

export default AddToListButton;
